import exp from 'constants';
import { get } from 'utils/ajax';

const productCache: Record<string, any> = {};

declare global {
  interface Window {
    Shopify?: {
      routes: any;
      locale?: string;
      country?: string;
    };
  }
}

export function getProduct(callback: (data: any, error?: Error) => void) {
  const pathname = window.location.pathname;
  const cacheKey = encodeURIComponent(pathname);

  if (productCache[cacheKey]) {
    callback(productCache[cacheKey]);
    return;
  }

  try {
    get({ url: window.location.origin.concat(pathname, '.js') }, (res) => {
      productCache[cacheKey] = res;
      callback(res);
    });
  } catch (error) {
    console.error('获取商品信息失败:', error);
    callback(null, error as Error);
  }
}

export function getCountryCode() {
  if (window?.Shopify?.routes?.root) {
    return window.Shopify.routes.root.replace(/\/$/, '');
  }
  return '';
}

export * from '@/utils/shopify/newsletter';
export * from '@/utils/shopify/utils';